import { useQuery } from 'convex/react';
import { api } from '@aeon-karaoke/cloud-convex';
import { cn } from '@/lib/cn';
import { AVATAR_ART_BASE } from './AvatarDisc';
import { Modal } from './Modal';
import { LoadingState } from './LoadingState';

interface AvatarPickerModalProps {
  open: boolean;
  onClose: () => void;
  current?: string;
  onPick: (key: string) => void;
}

/** Grid of the enabled catalog avatars; the equipped one carries a gold ring. */
export function AvatarPickerModal({ open, onClose, current, onPick }: AvatarPickerModalProps) {
  const catalog = useQuery(api.avatars.list, open ? {} : 'skip');
  return (
    <Modal open={open} onClose={onClose} title="Pick an avatar" kicker="Profile picture" maxWidth={520}>
      {!catalog ? (
        <LoadingState label="Loading avatars…" />
      ) : catalog.length === 0 ? (
        <p className="mt-6 text-sm text-mute">No avatars to pick from yet.</p>
      ) : (
        <div className="mt-6 grid grid-cols-5 gap-4">
          {catalog.map((avatar) => (
            <button
              key={avatar.key}
              type="button"
              aria-label={avatar.key}
              aria-pressed={avatar.key === current}
              onClick={() => onPick(avatar.key)}
              style={avatar.illustrated ? undefined : { background: avatar.bg }}
              className={cn(
                'flex h-16 w-16 items-center justify-center overflow-hidden rounded-full text-[26px]',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accFill',
                avatar.key === current && 'ring-2 ring-accFill ring-offset-2 ring-offset-surface'
              )}
            >
              {avatar.illustrated ? (
                <img src={`${AVATAR_ART_BASE}/${avatar.key}.png`} alt="" className="h-full w-full object-cover" />
              ) : (
                avatar.emoji
              )}
            </button>
          ))}
        </div>
      )}
    </Modal>
  );
}
